import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  constructor() { }

  isVisible = signal(false);
  description = signal('');
  private body = document.getElementsByTagName('body')[0];

  show(description?: string) {
    this.body.classList.add('body-overflow-hidden');
    this.description.set(description ?? '')
    this.isVisible.set(true);
  }

  hide() {
    this.body.classList.remove('body-overflow-hidden');
    this.description.set('');
    this.isVisible.set(false);
  }
}